import { USER_LOGOUT } from '../action-creators/ProfileActionCreators';
import { INewsForgeTranslationContent, initialNewsForgeState } from '../../views/Pages/NewsForge/models/news-forge.models';
import { NEWS_FORGE_CONTENT_UPDATE } from '../action-creators/news-forge-action-creator';

interface InitialState {
	newsForgeContent: INewsForgeTranslationContent;
}

const initialState: InitialState = {
	newsForgeContent: initialNewsForgeState,
};

function newsForgeReducer(state: Record<string, any> = initialState, action: any) {
	if (action.type === NEWS_FORGE_CONTENT_UPDATE) {
		return Object.assign({}, state, {
			newsForgeContent: action.payload.newsForgeContent,
		});
	}

	if (action.type === USER_LOGOUT) {
		state = initialState;
	}

	return state;
}

export default newsForgeReducer;
